'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.applyIdInvariant = undefined;

var _curry = require('transmute/curry');

var _curry2 = _interopRequireDefault(_curry);

var _indexedDataInvariant = require('../invariants/indexedDataInvariant');

var _getters = require('./getters');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Validate an id for IndexedAsyncData
 *
 * @param {Any} id an id that passes the id invariant
 * @param {IndexedAsyncData} indexedData IndexedAsyncData to get the entry in
 */
var applyIdInvariant = exports.applyIdInvariant = (0, _curry2.default)(function (id, indexedData) {
  (0, _indexedDataInvariant.indexedDataInvariant)(indexedData);

  var idInvariant = (0, _getters.getIdInvariant)(indexedData);
  var name = (0, _getters.getName)(indexedData);

  try {
    idInvariant(id);
  } catch (error) {
    error.indexedAsyncDataName = name;
    throw error;
  }
});